'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _formLabel = require('../formLabel');

var _select = require('../select');

require('./select-group.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH SelectGroup Component
 * @returns {ReactElement} The react component
 * @constructor
 */
var SelectGroup = function (_Component) {
    (0, _inherits3.default)(SelectGroup, _Component);

    function SelectGroup() {
        (0, _classCallCheck3.default)(this, SelectGroup);
        return (0, _possibleConstructorReturn3.default)(this, (SelectGroup.__proto__ || (0, _getPrototypeOf2.default)(SelectGroup)).apply(this, arguments));
    }

    (0, _createClass3.default)(SelectGroup, [{
        key: 'renderErrorText',
        value: function renderErrorText() {
            var errorText = this.props.errorText;


            if (errorText) {
                return (0, _jsx3.default)('p', {
                    className: 'sb-select-error'
                }, void 0, errorText);
            }

            return null;
        }
    }, {
        key: 'renderFormLabel',
        value: function renderFormLabel() {
            var _props = this.props,
                _props$id = _props.id,
                id = _props$id === undefined ? '' : _props$id,
                label = _props.label;


            if (label) {
                return (0, _jsx3.default)(_formLabel.FormLabel, {
                    htmlFor: id
                }, void 0, label);
            }

            return null;
        }
    }, {
        key: 'renderSelect',
        value: function renderSelect() {
            var _props2 = this.props,
                children = _props2.children,
                selectClassName = _props2.selectClassName;


            return _react2.default.createElement(
                _select.Select,
                (0, _extends3.default)({}, this.props, {
                    className: selectClassName
                }),
                children
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                _props3$className = _props3.className,
                className = _props3$className === undefined ? '' : _props3$className,
                _props3$isDisabled = _props3.isDisabled,
                isDisabled = _props3$isDisabled === undefined ? false : _props3$isDisabled,
                _props3$isValid = _props3.isValid,
                isValid = _props3$isValid === undefined ? false : _props3$isValid,
                _props3$hasErrors = _props3.hasErrors,
                hasErrors = _props3$hasErrors === undefined ? false : _props3$hasErrors;


            var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
                'sb-select-group': true,
                'sb-select-group--success': isValid,
                'sb-select-group--error': hasErrors,
                'sb-select-group--disabled': isDisabled
            }, '' + className, className));

            return (0, _jsx3.default)('div', {
                className: classNames
            }, void 0, this.renderFormLabel(), this.renderSelect(this.props), this.renderErrorText());
        }
    }]);
    return SelectGroup;
}(_react.Component);
// css

// components


exports.default = SelectGroup;
//# sourceMappingURL=SelectGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/selectGroup/SelectGroup.js
// module id = 601
// module chunks = 0